import { Component, OnInit, Input } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';
import { EnergyService } from '../../../energy/energy.service';
import { GeneralService } from '../../../../shared/services/general.service';
import { HomeService } from '../../home.service';

@Component({
  selector: 'app-home-flows-view',
  templateUrl: './home-flows-view.component.html',
  styleUrls: ['./home-flows-view.component.scss']
})
export class HomeFlowsViewComponent implements OnInit {
  @Input()
  gridInjection;
  @Input()
  selfConsumption;
  @Input()
  gridConsumption;
  @Input()
  consumptionSmartMeterIsOnline;
  @Input()
  atLeastOneProductionModuleIsOnline;
  @Input()
  injectionSmartMeterIsOnline;
  @Input()
  realTimeMessage: any;

  clientType: string;
  serviceSubscriptions: Map<string, string>;

  constructor(private sessionSateService: SessionStateService,
    private homeService: HomeService,
    private generalService: GeneralService) { }

  ngOnInit() {
  }

  showConsumptionFlow(): boolean {
    return (this.homeService.isConsumptionClient() || 
      this.homeService.isCommunityConsumption() ||
      this.homeService.isCommunitySelfConsumption());
  }

  showSelfconsumptionFlow(): boolean {
     return (this.homeService.isAutoConsumption() || 
      this.homeService.isAutoConsumptionWithBattery());
  }

  showBattery(): boolean {
    return this.homeService.isAutoConsumptionWithBattery();
  }

  showMicrogenerationFlow(): boolean {
    return this.homeService.isMicroGeneration() || this.homeService.isCommunityProduction();
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/home/home-tab/home-flows-view/home-flows-view.component.ts